import { Client } from 'hooks/webapi/useClient';

const userIsNotIdentified = (client: Client | undefined | null) =>
  client?.validationResolutionDetail === 'PERSONAL_ID_MISSING' ||
  client?.validationResolutionDetail === 'EXPIRED_IDENTITY_DOCUMENT';

export { userIsNotIdentified };
